import { render, staticRenderFns } from "./UserEditProfile.vue?vue&type=template&id=70a61548&scoped=true"
import script from "./UserEditProfile.vue?vue&type=script&lang=js"
export * from "./UserEditProfile.vue?vue&type=script&lang=js"
import style0 from "./UserEditProfile.vue?vue&type=style&index=0&id=70a61548&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a61548",
  null
  
)

export default component.exports